export { default } from './Carousel';
export type { CarouselImage } from './Carousel';
